module.exports = __webpack_public_path__ + "img/discount (3).a6b6c798.png";